<template>
  <div class="divide-y divide-gray-100">
    <div 
      v-for="integration in integrations" 
      :key="integration.id" 
      class="py-5 px-6 hover:bg-gray-50 transition-colors duration-200"
    >
      <div class="flex flex-row items-center justify-between">
        <!-- Sol taraf: Logo ve bilgiler -->
        <div class="flex items-center space-x-5 w-3/5">
          <div class="p-3 rounded-full bg-gray-100 flex-shrink-0">
            <img :src="integration.icon" :alt="integration.name" class="w-8 h-8">
          </div>
          <div class="flex-1">
            <div class="flex items-center gap-3 mb-2">
              <h3 class="font-medium text-gray-800 text-lg">{{ integration.name }}</h3>
              <div class="flex items-center bg-gray-100 px-2.5 py-1 rounded-full">
                <span class="w-2 h-2 rounded-full mr-1.5" 
                      :class="integration.connected ? 'bg-green-500' : 'bg-gray-300'"></span>
                <span class="text-xs font-medium" 
                      :class="integration.connected ? 'text-green-600' : 'text-gray-500'">
                  {{ integration.connected ? t('settings.components.integrations.connected') : t('settings.components.integrations.disconnected') }}
                </span>
              </div>
            </div>
            <p class="text-sm text-gray-500 max-w-xl pr-4">{{ integration.description }}</p>
          </div>
        </div>

        <!-- Sağ taraf: Butonlar -->
        <div class="flex items-center justify-end gap-4 w-2/5">
          <VButton 
            v-if="integration.connected"
            @click="$emit('manage', integration.id)"
            color="secondary"
            variation="outline"
            size="md"
            :button-text="t('settings.components.integrations.components.integrationCard.manage')"
            icon="settings"
            :show-icon="true"
          />

          <VButton 
            @click="$emit('toggle', integration.id)"
            :is-loading="integration.loading"
            :is-disabled="integration.loading || integration.disabled"
            :tooltip-text="integration.disabled ? integration.disabledTooltip : ''"
            :show-tooltip="integration.disabled"
            :color="integration.connected ? 'primary' : 'secondary'"
            size="md"
            :button-text="integration.connected ? t('settings.components.integrations.disconnect') : t('settings.components.integrations.connect')"
            :loading-text="t('settings.components.integrations.loading')"
            :icon="integration.connected ? 'link_off' : 'link'"
            :show-icon="true"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue'
import { useI18n } from 'vue-i18n'
import VButton from '@/components/base/buttons/VButton.vue'

const { t } = useI18n()

const props = defineProps({
  integrations: {
    type: Array,
    required: true
  }
})

defineEmits(['toggle', 'manage'])
</script>
